import React from 'react';
import { Outlet } from 'react-router-dom';

const ReportsLayout = () => {
  return (
    <div className="max-w-6xl mx-auto p-6">
      <Outlet />
    </div>
  );
};

export default ReportsLayout; 